module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_180deg.be6c7a83.png";